import { abyssColors } from '@/theme/colors';
import { Box, Typography, TypographyProps, styled as muiStyled } from '@mui/material';

export const ColumnTitleTypography = muiStyled(Typography)(() => ({
  fontWeight: 500,
  fontSize: '12px',
  lineHeight: '16px',
  letterSpacing: '0.5px',
  marginLeft: '10px',
  color: abyssColors.primary[400],
}));

interface RowValueTypographyProps extends TypographyProps {
  isNA?: boolean;
}

export const RowValueTypography = muiStyled(Typography)<RowValueTypographyProps>(({ isNA }) => ({
  fontSize: '14px',
  fontWeight: 400,
  color: isNA ? abyssColors.primary[400] : abyssColors.primary[900],
  paddingLeft: '10px',
}));

export const AlarmLevelBox = muiStyled(Box, {
  shouldForwardProp: (property) => property !== 'level',
})<{ level: string }>(({ level }) => ({
  display: 'inline-block',
  width: '8px',
  height: '8px',
  marginRight: '8px',
  borderRadius: '2px',
  backgroundColor:
    level === '3'
      ? '#DD0004'
      : level === '2'
        ? '#FF7E80'
        : level === '1'
          ? '#EAB308'
          : 'transparent',
}));

export const tableCellStyle = {
  border: `1px solid ${abyssColors.primary[100]}`,
  whiteSpace: 'nowrap',
  padding: '8px',
};

export const removeChaseItemsDialog = {
  top: '10% !important',
  left: 'calc(50% - 268px)',
  transform: 'none',
  borderRadius: '8px',
  width: 500,
  height: 160,
};
